import AUTH_BASE_URL from "../AUTH_BASE_URL";

export default async function getAllUAssets () {
    return await fetch(`${AUTH_BASE_URL}assets`, {
    }).then((response => {
        return response.json()
    })).then((data => {
        return data
    }))
}